import * as React from "react";
import styles from "./Popover.scss";
import PopoverPane, { PopoverPaneWrapper } from "./PopoverPaneWrapper/PopoverPaneWrapper";

interface IProps {
    id?: string;
    className?: string;
    title: string;
    children?: React.ReactNode[] | React.ReactNode;
    onClose: () => void;
    isOpen: boolean;
    paneIndex: number;
    addChild: () => void;
    deleteChild: (childNumber: number) => void;
    onIndexChange?: (itemIndex: number) => void;
    addItemText: string;
    additionalHeaderControl?: JSX.Element;
}

interface IState {
    currentPaneIndex: number;
    isOpen: boolean;
}

export class Popover extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            currentPaneIndex: props.paneIndex,
            isOpen: props.isOpen
        };

        this.nextPane = this.nextPane.bind(this);
        this.previousPane = this.previousPane.bind(this);
        this.deletePane = this.deletePane.bind(this);
    }

    public static getDerivedStateFromProps(nextProps: IProps, prevState: IState): Partial<IState | null> {
        if (nextProps.isOpen !== prevState.isOpen) {
            return { isOpen: nextProps.isOpen, currentPaneIndex: nextProps.paneIndex };
        }
        return null;
    }

    private getPanes(): React.ReactNode[] {
        if (Array.isArray(this.props.children)) {
            return this.props.children;
        }
        else {
            return [this.props.children];
        }
    }

    public nextPane() {
        const totalPanes = this.getPanes().length;
        if (totalPanes) {
            if (this.state.currentPaneIndex >= totalPanes - 1) {
                this.props.addChild();
            }
            this.setState({ currentPaneIndex: this.state.currentPaneIndex + 1 });
        }
    }

    public previousPane() {
        const totalPanes = this.getPanes().length;
        if (totalPanes && this.state.currentPaneIndex > 0) {
            this.setState({ currentPaneIndex: this.state.currentPaneIndex - 1 });
        }
    }

    public componentDidUpdate(prevProps: IProps, prevState: IState) {
        if (this.state.currentPaneIndex !== prevState.currentPaneIndex && this.props.onIndexChange) {
            this.props.onIndexChange(this.state.currentPaneIndex);
        }
    }

    public deletePane(currentStep: number) {
        const totalPanes = this.getPanes().length;
        if (totalPanes && this.props.deleteChild) {
            this.props.deleteChild(currentStep);
            if (totalPanes > 1) {
                const currentPaneIndex = this.state.currentPaneIndex - 1;
                this.setState({ currentPaneIndex: currentPaneIndex < 0 ? 0 : currentPaneIndex });
            }
            else {
                this.props.onClose();
            }
        }
    }

    public render() {
        const panes = this.getPanes();
        const pane = panes[this.state.currentPaneIndex];
        const totalPanes = panes.length;

        return (
            <div id="divPopupOverlay" className={`${styles.overlay} ${this.state.isOpen ? styles.open : styles.closed}`} onClick={this.props.onClose}>
                <div className={styles.popover} onClick={(e) => e.stopPropagation()}>
                    <PopoverPaneWrapper
                        id={this.props.id}
                        title={this.props.title}
                        currentStep={this.state.currentPaneIndex + 1}
                        totalSteps={totalPanes}
                        nextPane={this.nextPane}
                        previousPane={this.previousPane}
                        deletePane={this.deletePane}
                        addItemText={this.props.addItemText}
                        additionalHeaderControl={this.props.additionalHeaderControl}
                        className={this.props.className}
                    >
                        {pane}
                    </PopoverPaneWrapper>
                </div>
            </div>
        );
    }
}

export default Popover;


// WEBPACK FOOTER //
// ./src/Components/Common/Popover/Popover.tsx